import {
  retryChecklistGooglePush,
  type RetryGooglePushRequest,
  type RetryGooglePushSuccess,
} from "@workspace/api-client-react";

/**
 * Web wrapper around the generated retry-google-push client call.
 *
 * The generated customFetch does NOT default to sending cookies, but this
 * endpoint is session-authenticated on the web — so the session cookie must
 * be included explicitly or every retry would 401.
 */
export function retryGooglePush(
  checklistId: string,
  body: RetryGooglePushRequest,
): Promise<RetryGooglePushSuccess> {
  return retryChecklistGooglePush(checklistId, body, {
    credentials: "include",
  });
}
